export default "__VITE_ASSET__26700db9__"